import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";

import { BotModule } from "@app/bot/bot.module";
import { SharedModule } from "@app/shared/shared.module";
import { SharedComponentsModule } from "@app/components/shared-components.module";

import { MyExamCreatePage } from "./my-exam-create.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BotModule,
    SharedComponentsModule,
    SharedModule
  ],
  declarations: [MyExamCreatePage],
})
export class MyExamCreatePageModule {}
